import { React } from "ui-kit";

const defaultValue: {
  getLogoutUrls: () => string[];
  addLogoutUrl?: (v: string) => void;
} = {
  getLogoutUrls: () => [],
};

export const LogoutUrlContext = React.createContext(defaultValue);
